<template>
  <section class="tools">
    <ul class="tools-list">
      <li class="tools-item" v-if="publishVisible">
        <a class="tools-box" :title="publishTitle" :href="publishURL" target="_blank">
          <i class="yk-suspension_write"></i>
        </a>
      </li>

      <li class="tools-item" v-if="merchantVisible">
        <a
          class="tools-box"
          title="进入商家管理中心"
          :href="'/' | hostBuild('merchant')"
          target="_blank"
          v-if="$store.getters.isLogin"
        >
          <i class="yk-merchant_shop"></i>
        </a>
        <button class="tools-box" title="进入商家管理中心" @click="$store.commit('showLoginDialog')" v-else>
          <i class="yk-merchant_shop"></i>
        </button>
      </li>

      <li class="tools-item" v-if="homeVisible">
        <a class="tools-box" title="进入个人中心" :href="homeURL" target="_blank" v-if="$store.getters.isLogin">
          <i class="yk-house_user"></i>
        </a>
        <button class="tools-box" title="进入个人中心" @click="$store.commit('showLoginDialog')" v-else>
          <i class="yk-house_user"></i>
        </button>
      </li>

      <li class="tools-item" v-if="downloadVisible">
        <a class="tools-box" title="APP下载" target="_blank" :href="`/app` | hostBuild('corp')">
          <i class="yk-iphone-line"></i>
        </a>
      </li>

      <li class="tools-item" v-if="opinionVisible">
        <button class="tools-box" title="意见反馈" @click="feedbackVisible = true">
          <i class="yk-suspension_opinion"></i>
        </button>
      </li>

      <li class="tools-item" v-show="backTopVisible">
        <button class="tools-box" title="返回顶部" @click="reachPageTop">
          <i class="yk-news_up"></i>
        </button>
      </li>
      <li class="tools-item" v-show="!backTopVisible">
        <button class="tools-box" title="直达底部" @click="reachPageBottom">
          <i class="yk-news_down"></i>
        </button>
      </li>
    </ul>

    <!-- 意见反馈对话框 -->
    <el-dialog
      class="feedback-dialog"
      v-if="feedbackVisible"
      :visible.sync="feedbackVisible"
      title="意见反馈"
      width="600px"
      append-to-body
    >
      <el-form label-width="50px" size="small">
        <el-form-item label="建议" required>
          <el-input
            type="textarea"
            :rows="5"
            resize="none"
            clearable
            placeholder="有什么好或不好的地方，请大声说出来！我们会关注您的反馈，不断优化产品，为您提供更好的服务！"
            v-model="form.content"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <YorkbbsUploder class="feedback-uploader" :uploadLimit="9" :fileList.sync="form.imageList">
            <div class="uploader-main">
              <el-button type="primary" plain icon="el-icon-plus">上传图片</el-button>
              <div class="uploader-main__tip" @click.prevent.stop>图片补充您的反馈</div>
            </div>
          </YorkbbsUploder>
          <div class="feedback-image__list" v-if="form.imageList.length">
            <YorkbbsImage class="feedback-image__item" v-for="(item, i) in form.imageList" :key="i" :src="item">
              <button class="feedback-image__close" @click="removeImage(i)">
                <i class="el-icon-close"></i>
              </button>
            </YorkbbsImage>
          </div>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input
            class="feedback-input"
            clearable
            placeholder="请输入 Email ，方便更好的联系您"
            v-model="form.email"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="feedbackVisible = false">取消</el-button>
        <el-button type="primary" @click="submitFeedback" :loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import YorkbbsUploder from '@/common/uploader-desktop.vue';
import { regexEmail } from '@/common/account/utils/regex';
export default {
  name: 'ToolsBackup',
  components: { YorkbbsUploder },
  props: {
    // 发布显示
    publishVisible: Boolean,
    // 发布的title
    publishTitle: String,
    // 发布地址
    publishURL: String,
    // 个人中心显示
    homeVisible: Boolean,
    // 个人中心地址
    homeURL: String,
    // 意见反馈显示
    opinionVisible: Boolean,
    // 下载APP显示
    downloadVisible: Boolean,
    // 商家中心显示
    merchantVisible: Boolean,
  },
  data() {
    return {
      // 返回顶部显示状态
      backTopVisible: false,

      // 意见反馈显示
      feedbackVisible: false,

      // 意见反馈
      form: {
        content: '',
        email: undefined,
        imageList: [],
      },
      // 意见反馈提交状态
      loading: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, false);
    this.$once('beforeDestroy', () => {
      window.removeEventListener('scroll', this.onScroll, false);
    });
  },
  methods: {
    /**
     * 页面发生滚动时
     */
    onScroll() {
      const top = document.documentElement.scrollTop || document.body.scrollTop;
      this.backTopVisible = top > 0;
    },
    /**
     * 滚动到页面顶部
     */
    reachPageTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    /**
     * 滚动到页面底部
     */
    reachPageBottom() {
      window.scrollTo({
        top: document.documentElement.offsetHeight,
        behavior: 'smooth',
      });
    },
    /**
     * 删除图片
     */
    removeImage(index) {
      const imageList = this.form.imageList.splice(index, 1);
      this.imageList = imageList;
    },
    /**
     * 提交反馈
     */
    async submitFeedback() {
      const content = this.form.content.trim();
      if (!content.length) return this.$warning('请输入反馈内容');

      if (this.form.email && !regexEmail.test(this.form.email)) return this.$warning('邮箱格式不正确');

      this.loading = true;
      await this.$axios.post('user/v1/feedback', { ...this.form }).finally(() => {
        this.loading = false;
      });

      this.$success('反馈内容提交成功');
      this.feedbackVisible = false;
      this.form = this.$options.data()['form'];
    },
  },
};
</script>
<style lang="scss" scoped>
.tools {
  position: fixed;
  left: calc(50% + 650px);
  bottom: 100px;
  z-index: 5;
  box-sizing: border-box;
}
.tools-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tools-item {
  box-sizing: border-box;
  border: 1px solid #eee;
  overflow: hidden;
  &:nth-child(n + 2) {
    border-top: 0 none;
  }
  &:first-child {
    border-radius: 6px 6px 0 0;
  }
  &:last-child {
    border-radius: 0 0 6px 6px;
  }
}
.tools-box {
  width: 58px;
  height: 50px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: var(--text-color-6);
  &:hover {
    background-color: #f8f8f8;
  }
}

.feedback-uploader {
  ::v-deep {
    .el-upload-dragger {
      width: auto;
      height: auto;
      flex-direction: row;
      border: 0 none;
      overflow: initial;
    }
  }
  .uploader-main {
    display: flex;
    align-items: center;
  }
  .uploader-main__tip {
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color-9);
    margin-left: 10px;
    cursor: default;
  }
}
.feedback-image__list {
  display: flex;
  flex-wrap: wrap;
}
.feedback-image__item {
  width: 80px;
  height: 60px;
  border-radius: 4px;
  margin-right: 16px;
  margin-top: 16px;
}
.feedback-image__close {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #000;
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 1;
  i {
    color: #fff;
    font-size: 10px;
  }
}
.feedback-input {
  width: 300px;
}
</style>
